import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isTextTruncated',
  standalone: false,
  pure: false,
})
export class IsTextTruncatedPipe implements PipeTransform {
  transform(element: HTMLElement | null): boolean {
    if (!element) {
      return false;
    }

    return element.offsetWidth < element.scrollWidth;
  }
}
